import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "space-y-7 px-8 pb-6 pt-7" }
const _hoisted_3 = { class: "space-y-1.5" }
const _hoisted_4 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_5 = { class: "text-sm text-gray-500" }
const _hoisted_6 = { class: "border-b border-gray-200 pb-4" }
const _hoisted_7 = { style: {"height":"46px"} }
const _hoisted_8 = { class: "space-y-2" }
const _hoisted_9 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_10 = { class: "absolute right-3 top-1/2 flex -translate-y-1/2 flex-col text-gray-400" }
const _hoisted_11 = { class: "text-xs text-gray-400" }
const _hoisted_12 = { class: "space-y-1" }
const _hoisted_13 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_14 = {
  key: 0,
  class: "pt-2 text-sm text-gray-500"
}
const _hoisted_15 = { class: "max-h-72 overflow-y-auto divide-y divide-gray-100" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "space-y-1" }
const _hoisted_18 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_19 = {
  key: 0,
  class: "inline-block rounded bg-emerald-50 px-1.5 py-0.5 text-[0.65rem] font-medium text-emerald-700"
}
const _hoisted_20 = {
  key: 1,
  class: "inline-block rounded bg-gray-100 px-1.5 py-0.5 text-[0.65rem] font-medium text-gray-500"
}
const _hoisted_21 = {
  key: 2,
  class: "inline-block rounded bg-gray-100 px-1.5 py-0.5 text-[0.65rem] font-medium text-gray-400"
}
const _hoisted_22 = { class: "flex items-center gap-3" }
const _hoisted_23 = { class: "relative w-28" }
const _hoisted_24 = { class: "absolute right-2 top-1/2 flex -translate-y-1/2 flex-col text-gray-400" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "flex justify-end gap-3 border-t border-gray-100 px-8 py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Target = _resolveComponent("Target")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CloseModalButton = _resolveComponent("CloseModalButton")!
  const _component_PigTypePicker = _resolveComponent("PigTypePicker")!
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_ChevronUp = _resolveComponent("ChevronUp")!
  const _component_ChevronDown = _resolveComponent("ChevronDown")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "close-esc-event": "keydown",
    "close-button": false,
    "modal-class": "w-full max-w-xl bg-white m-auto rounded-xl border-0",
    "mask-class": "grid",
    onState: _ctx.captureModalApi
  }, {
    toggle: _withCtx((scope) => [
      (_ctx.showTrigger)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            variant: "default",
            size: "sm",
            class: "self-center",
            onClick: () => _ctx.openAndLoad(scope.open)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Target, { class: "h-3.5 w-3.5" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('views.objectives.modal.openButton')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    header: _withCtx((scope) => [
      _createVNode(_component_CloseModalButton, {
        onClose: () => _ctx.onClose(scope.close)
      }, null, 8, ["onClose"])
    ]),
    body: _withCtx((scope) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('views.objectives.modal.title')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('views.objectives.modal.description')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_PigTypePicker, { slim: "" })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('views.objectives.modal.defaultSection')), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["relative", ['rounded-md transition-colors', { 'objective-row-flash': _ctx.highlighted.has('default') }]])
            }, [
              _createVNode(_component_CustomInput, {
                value: _ctx.directoryDefault,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.directoryDefault) = $event)),
                label: _ctx.$t('views.objectives.modal.targetLabel'),
                "input-type": "number",
                step: "0.1",
                min: "0",
                max: "100",
                required: false,
                rules: []
              }, null, 8, ["value", "label"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "flex h-4 w-5 items-center justify-center hover:text-primary-700",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stepDefault(0.1)))
                }, [
                  _createVNode(_component_ChevronUp, { class: "h-3.5 w-3.5" })
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "flex h-4 w-5 items-center justify-center hover:text-primary-700",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.stepDefault(-0.1)))
                }, [
                  _createVNode(_component_ChevronDown, { class: "h-3.5 w-3.5" })
                ])
              ])
            ], 2),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('views.objectives.modal.leaveEmptyHint')), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h2", _hoisted_13, _toDisplayString(_ctx.$t('views.objectives.modal.overridesSection')), 1),
            (!_ctx.loading && _ctx.rows.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.$t('views.objectives.modal.noFarms')), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: "grid items-center gap-4 border-b border-gray-200 pb-2 pt-1 text-xs font-medium uppercase tracking-wide text-gray-400",
                    style: _normalizeStyle(_ctx.gridCols)
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.objectives.modal.colFarm')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.objectives.modal.colEffective')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.objectives.modal.colOverride')), 1)
                  ], 4),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: row.locationId,
                        ref_for: true,
                        ref: (el) => _ctx.setRowEl(row.locationId, el as Element | null),
                        class: _normalizeClass(["grid items-center gap-4 py-3", { 'objective-row-flash rounded-md': _ctx.highlighted.has(row.locationId) }]),
                        style: _normalizeStyle(_ctx.gridCols)
                      }, [
                        _createElementVNode("span", {
                          class: "min-w-0 truncate text-sm font-medium text-gray-800",
                          title: row.name
                        }, _toDisplayString(row.name), 9, _hoisted_16),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.effectiveLabel(row)), 1),
                          (row.override !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('views.objectives.modal.badgeCustom')), 1))
                            : (_ctx.directoryDefault !== null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('views.objectives.modal.badgeDefault')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('views.objectives.modal.badgeNone')), 1))
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.isEditing(row))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_CustomInput, {
                                    value: row.override,
                                    "onUpdate:value": ($event: any) => ((row.override) = $event),
                                    label: "",
                                    "input-type": "number",
                                    step: "0.1",
                                    min: "0",
                                    max: "100",
                                    required: false,
                                    rules: []
                                  }, null, 8, ["value", "onUpdate:value"]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "flex h-4 w-5 items-center justify-center hover:text-primary-700",
                                      onClick: ($event: any) => (_ctx.stepRow(row, 0.1))
                                    }, [
                                      _createVNode(_component_ChevronUp, { class: "h-3.5 w-3.5" })
                                    ], 8, _hoisted_25),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "flex h-4 w-5 items-center justify-center hover:text-primary-700",
                                      onClick: ($event: any) => (_ctx.stepRow(row, -0.1))
                                    }, [
                                      _createVNode(_component_ChevronDown, { class: "h-3.5 w-3.5" })
                                    ], 8, _hoisted_26)
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "shrink-0 text-sm font-medium text-primary-700 hover:underline",
                                  onClick: ($event: any) => (_ctx.useDefault(row))
                                }, _toDisplayString(_ctx.$t('views.objectives.modal.resetButton')), 9, _hoisted_27)
                              ], 64))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "rounded-lg border border-primary-600 px-3 py-1.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50",
                                onClick: ($event: any) => (_ctx.setCustom(row))
                              }, _toDisplayString(_ctx.$t('views.objectives.modal.setCustom')), 9, _hoisted_28))
                        ])
                      ], 6))
                    }), 128))
                  ])
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_Button, {
            variant: "outline",
            onClick: () => _ctx.onClose(scope.close)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.objectives.modal.close')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]),
          _createVNode(_component_Button, {
            variant: "default",
            loading: _ctx.saving,
            disabled: !_ctx.isDirty,
            onClick: _ctx.onSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.objectives.modal.saveChanges')), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onState"]))
}